<div class="columnTransaction">
  <div class="boxTransaction">
    <div *ngIf="!mobile">
      <h1>{{ 'transInfo-Title' | translation | async }}</h1>
      <p *ngIf="!(hideReference && flagActive)">{{ 'transInfo-RefPago' | translation | async }}  {{ transaction.ORDER_REFERENCE }}</p>
      <p>{{ 'transInfo-Descrip' | translation | async }} {{ transaction.ORDER_BRIEF }}</p>
      <p>{{ 'transInfo-Shop' | translation | async }} {{ transaction.MERCHANT_NAME }}</p>
      <p *ngIf="transaction.MERCHANT_EMAIL" >{{ 'transInfo-Email' | translation | async }} {{ transaction.MERCHANT_EMAIL }}</p>
      <div class="flexBox" style="justify-content: space-between;">
        <p *ngIf="transaction.MERCHANT_CEL" class="column mr-0" style="flex: unset;" >
          {{ 'transInfo-Cel' | translation | async }} {{ transaction.MERCHANT_CEL }}</p>
        <p *ngIf="transaction.MERCHANT_TEL " class="column mr-0" style="flex: unset;" >
          {{ 'transInfo-Tel' | translation | async }} {{ transaction.MERCHANT_TEL }}</p>
      </div>

      <br />
      <div class="flexBox cssValor">
        <p class="column al-Left">{{ 'transInfo-Total' | translation | async }}</p>
        <p class="column al-Right">{{ transaction.ORDER_CURRENCY }} {{ transaction.ORDER_AMOUT | number: '1.2-2' }}</p>
      </div>
    </div>
    <div *ngIf="mobile" class="flexBox cssValor">
      <div class="column al-Left">
        <p class="mr-0" style="font-size: .8rem">{{'transInfo-RefPago-Mobile' | translation | async }}</p>
        <p class="noBold mr-0">{{ transaction.ORDER_REFERENCE }}</p>
      </div>
      <div class="column al-Right">
        <p class="mr-0" style="font-size: .8rem" >{{ 'transInfo-Total' | translation | async }}</p>
        <p class="noBold mr-0">{{ transaction.ORDER_CURRENCY}} {{ transaction.ORDER_AMOUT | number: '1.2-2' }}</p>
      </div>
    </div>
  </div>

  <div class="footer2" *ngIf="!mobile">
    <app-footer></app-footer>
  </div>

</div>


